import Banner from '../../assets/icons/login-banner.svg';
import Glass from '../../assets/icons/glass.svg';
import Joomla from '../../assets/icons/joomla.svg';

const PreLoginBanner = () => <div className="col d-none d-lg-block col-lg-6">
<div className="bg-login full-height">
    <div className="d-flex justify-content-center align-items-center full-height">
        <div className="login-tile">
            <img src={Banner} alt="banner"/>
            <div className="avatar glass-avatar">
                <img src={Glass} alt="Glass"/>
            </div>
            <div className="avatar joomla-avatar">
                <img src={Joomla} alt="Joomla"/>
            </div>
        </div>                    
    </div>                
</div>
</div>
export default PreLoginBanner;